/**
 * FS-562: signature of the inputs that legitimately move the board camera — the
 * visible page, whether the chat panel actually reserves layout width, and the
 * set of visible documents. The board's layout effect re-runs on incidental
 * changes too (autosave, card selection); we only re-fit/re-center when this
 * signature changes (or on first paint), so the camera stops jumping on those.
 *
 * `chatAffectsLayout` — NOT the raw chat-open flag — is what belongs here: the
 * chat panel only reserves width on V2, non-embed boards, so toggling chat on a
 * V1 / embed board must not change the signature (it would otherwise trigger a
 * superfluous 300ms re-center that computes the identical camera position).
 */
export function boardLayoutSignature(params: {
  canvasDocsPage: number
  chatAffectsLayout: boolean
  visibleDocumentIds: string[]
}): string {
  const { canvasDocsPage, chatAffectsLayout, visibleDocumentIds } = params
  return `${canvasDocsPage}|${chatAffectsLayout ? 1 : 0}|${visibleDocumentIds.join(',')}`
}
